import { useRoutes } from "react-router-dom";
import Error from "../pages/Error";
import Home from "../pages/Home";
import Gameflow from "../pages/Gameflow";
import Tokonomics from "../pages/Tokonomics";
import Roadmap from "../pages/Roadmap";
import Whitepaper from "../pages/Whitepaper";

export default function WebRouter() {
  let routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "*", element: <Error /> },
    { path: "/gameflow", element: <Gameflow /> },
    { path: "/tokenomics", element: <Tokonomics /> },
    { path: "/roadmap", element: <Roadmap /> },
    { path: "/whitepaper", element: <Whitepaper /> },
  ]);
  return routes;
}